export const onGridSizeChangedEvent = ({ params, onGridSizeChanged }) => {
  if (onGridSizeChanged) onGridSizeChanged(params);
}